import React from 'react';

import TimelineNumberChart from './TimelineNumberChart';

class TimelineView extends React.PureComponent {
  render() {
    const { results, participation, numberStates } = this.props;

    return (
      <TimelineNumberChart
        results={ results }
        participation={ participation }
        numberStates={ numberStates }
      />
    );
  }
}

export default TimelineView;



// WEBPACK FOOTER //
// ./src/components/Statistics/Views/TimelineView.js